<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title v-if="orderResultData.pay_type === 'alipay'">
            <span class="headline"
              >打开<span class="text-primary">支付宝</span
              >扫描二维码完成支付</span
            >
          </v-card-title>
          <v-card-title v-else>
            <span class="headline"
              >打开<span class="text-success">微信</span
              >扫描二维码完成支付</span
            >
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <div class="text-center">
                <b-img :src="orderResultData.url" fluid alt="qr code"></b-img>
                <p class="font-size-h2">
                  请在<span class="text-danger">{{ time }}</span
                  >内完成支付
                </p>
                <p>支付完成后,请稍等几秒钟,页面将会自动跳转。</p>
                <p>
                  如果页面没有自动跳转，请<a
                    class="text-primary text-hover-danger"
                    href="/oms/dashboard"
                    >点击这里</a
                  >进入后台查看最近订单
                </p>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <PaySuccess
      :order="order"
      v-bind:dialog.sync="PaySuccessDialog"
    ></PaySuccess>
  </div>
</template>

<script>
import { checkOrderStatus } from "@/api/pay";
import { getInstance } from "@/api/instance";
import PaySuccess from "@/view/pages/pay/PaySuccess";
export default {
  name: "Qrcode",
  components: {
    PaySuccess,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    orderResultData: {
      type: Object,
      required: true,
      default: () => ({
        order_id: "",
        url: "",
        pay_type: "",
      }),
    },
  },
  watch: {
    dialog: function (val) {
      if (val) {
        this.checkStatus();
      } else {
        clearInterval(this.timer);
      }
    },
  },
  data() {
    return {
      second: 1800,
      today: "",
      time: "",
      PaySuccessDialog: false,
      order: {
        action: "",
        prices: "",
        product: {
          code: "",
        },
        ctime: "",
      },
    };
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);
    },
    checkStatus() {
      this.timer = setInterval(() => {
        checkOrderStatus({ _id: this.orderResultData.order_id }).then((res) => {
          this.second--;
          const time = this.$moment.duration(this.second, "seconds");
          this.time = time.minutes() + "分钟" + time.seconds() + "秒";
          if (this.second <= 0) {
            this.time = "已过期，请重新刷页面";
            clearInterval(this.timer);
          }

          if (res.status === 1) {
            clearInterval(this.timer);
            this.today = this.$moment().unix();
            // 关闭qr code dialog
            this.$emit("update:dialog", false);
            // 打开支付成功页面
            this.fetchOrder();
            this.PaySuccessDialog = true;
          }
        });
      }, 1000);
    },
    fetchOrder() {
      getInstance("ORDER", { _id: this.orderResultData.order_id }).then(
        (res) => {
          this.order = res.result[0];
        }
      );
    },
  },
};
</script>

<style scoped></style>
